import { useEffect, useState } from "react";
import { useAuth } from "../_providers/AuthProvider";
import "./Header.css";
import Invite from "../models/Invite";
import CategoryController from "../controllers/CategoryController";
import InviteController from "../controllers/InviteController";
import { usePlan } from "../_providers/PlanProvider";
import { NavLink, useLocation, useParams } from "react-router-dom";
import LangController from "../controllers/LangController";

const Header = () => {
    const [openMessages, setOpenMessages] = useState(false);
    const [openLanguage, setOpenLanguage] = useState(false);
    const [openUser, setOpenUser] = useState(false);

    const [languages, setLanguages] = useState<any[]>([]);

    const loc = useLocation();
    const {lang} = useParams();

    const [receivedInvites, setReceivedInvites] = useState<Invite[]>([]);
    const [error, setError] = useState("");
    const {logOut, user} = useAuth();
    const {reloadPlans} = usePlan();

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
          const modalElement = document.getElementById('modal');
          if (modalElement && !modalElement.contains(event.target as Node)) {
            setOpenMessages(false);
            setOpenLanguage(false);
            setOpenUser(false);
          }
        };
    
        document.addEventListener('mousedown', handleClickOutside);

        reloadInviteData();
        langData();
      }, []);
    
    const langData = () => {
        LangController.getLangs().then((langs) => {
            setLanguages(langs);
        });
    }

    const reloadInviteData = () => {
        if(!user) {
            return;
        }
        InviteController.getInvites(user?.uid).then((invites) => {
            setReceivedInvites(invites);
        }).catch((error) => {
            setError(error.message);
        });
    }

    const onAccept = (invite: Invite) => {
        InviteController.acceptInvite(invite).then(() => {
            reloadInviteData();
            reloadPlans();
        }).catch((error) => {
            setError(error.message);
        });
    }
    
    const onDecline = (invite: Invite) => {
        InviteController.declineInvite(invite).then(() => {
            reloadInviteData();
        }).catch((error) => {
            setError(error.message);
        });
    }

    return (
        <div className="header-container">
            <div className="header">
                <p className="title">EasyFin<span className="subtitle">a floren app</span></p>
                <div className="buttons">
                    <div className="button" onClick={() => setOpenMessages(true)}>
                        <i className="fa-solid fa-message"></i>
                        {receivedInvites.length > 0 ? <div className="count-indicator">{receivedInvites.length}</div> : null}
                        {openMessages ? <div id="modal" className="modal">
                            <div style={{padding: "10px 10px"}}>
                                <p style={{fontSize: 16, fontWeight: "bold", margin: 0, marginBottom: 10}}>Notifications</p>
                                {receivedInvites.map((invite) => (
                                    <div className="invite-container" key={invite.uid}>
                                    <b>Invite to plan</b>
                                    <p className="invite-message" key={invite.uid}>
                                        {invite.message}
                                    </p>
                                    <div className="invite-actions">
                                        <div
                                            style={{width: 20, height: 20}}
                                            className="action-button"
                                            onClick={() => onAccept(invite)}
                                        >
                                            <i className="fa-solid fa-check"></i>
                                        </div>
                                        <div
                                            style={{width: 20, height: 20}}
                                            className="action-button decline"
                                            onClick={() => onDecline(invite)}
                                        >
                                            <i className="fa-solid fa-times"></i>
                                        </div>
                                    </div>
                                </div>
                                ))}
                                {receivedInvites.length === 0 ? <p style={{width: 250}}>No notifications</p> : null}
                            </div>
                        </div> : null}
                    </div>
                    <div className="button" onClick={() => setOpenLanguage(true)}>
                        <i className="fa-solid fa-language"></i>
                        {openLanguage ? <div id="modal" className="modal">
                            <div>
                            {languages.map((language, index) => (
                                <NavLink
                                    to={loc.pathname.replace(lang as string, language.uid)}
                                    key={language.uid}
                                    className="nav-link"
                                >
                                    <div className={`lang-option ${index === 0 ? 'first' : 'not-first'}`} key={language.uid}>
                                        <p className="lang-text">{language.uid + ' '}</p>
                                        {lang === language.uid ? <i className="fa-solid fa-check"></i> : null}
                                    </div>
                                </NavLink>
                            ))}
                            </div>
                        </div> : null}
                    </div>
                    <div className="profile" onClick={() => setOpenUser(true)}>
                        <i className="fa-solid fa-circle-user"></i>
                        <p>{user?.displayName}</p>
                        {openUser ? <div id="modal" style={{right: 0}} className="modal">
                        <div style={{width: 250, padding: 20}}>
                            <p style={{margin: 0}}><b>{user?.displayName}</b></p>
                            <p style={{margin: 0}}>{user?.email}</p>
                            <div className="user-actions" style={{display: "flex", flexDirection: "row", gap: 10, marginTop: 20}}>
                                <div className="action-button" style={{flex: 1, display: "flex", gap: 10, alignItems: "center"}} onClick={() => setOpenUser(false)}>
                                    <i style={{fontSize: 14}} className="fa-solid fa-gear"></i><b>Settings</b>
                                </div>
                                <div className="action-button" style={{flex: 1, display: "flex", gap: 10, alignItems: "center"}} onClick={() => logOut()}>
                                    <i style={{fontSize: 14}} className="fa-solid fa-right-from-bracket"></i><b>Logout</b>
                                </div>
                            </div>
                        </div>
                        </div> : null}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Header;